"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const notification_service_1 = require("./notification.service");
const notification_controller_1 = require("./notification.controller");
const email_service_1 = require("./email.service");
const notification_repository_1 = require("./notification.repository");
const notification_event_type_entity_1 = require("../../../../service-lib/src/lib/entities/notification-event-type.entity");
const notification_event_template_mapping_entity_1 = require("../../../../service-lib/src/lib/entities/notification-event-template-mapping.entity");
const notification_template_entity_1 = require("../../../../service-lib/src/lib/entities/notification-template.entity");
const notification_log_entity_1 = require("../../../../service-lib/src/lib/entities/notification-log.entity");
const notification_in_app_entity_1 = require("../../../../service-lib/src/lib/entities/notification-in-app.entity");
const notififcation_log_receiver_record_entity_1 = require("../../../../service-lib/src/lib/entities/notififcation-log-receiver-record.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
let NotificationModule = class NotificationModule {
};
exports.NotificationModule = NotificationModule;
exports.NotificationModule = NotificationModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                notification_event_type_entity_1.NotificationEventType,
                notification_event_template_mapping_entity_1.NotificationEventTemplateMapping,
                notification_template_entity_1.NotificationTemplate,
                notification_log_entity_1.NotificationLog,
                notification_in_app_entity_1.NotificationInApp,
                notififcation_log_receiver_record_entity_1.NotificationLogReceiverRecord,
                look_up_entity_1.LookUp
            ]),
        ],
        controllers: [notification_controller_1.NotificationController],
        providers: [notification_service_1.NotificationService, email_service_1.EmailService, notification_repository_1.NotificationRepository, entity_service_utils_1.EntityService],
    })
], NotificationModule);
